<template>
  <div class="login-container">
    <section class="login-section">
      <div class="container">
        <h3 class="text-center">We just need a few details to create your account and get you on your way.</h3>
        <form @submit.prevent="login">
          <div class="form-group">
            <label for="email">Official Email Address</label>
            <input
              type="email"
              v-model="email"
              id="email"
              class="form-control"
              placeholder="jane.doe@gmail.com"
              required
            />
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <div class="password-container">
              <input
                type="password"
                v-model="password"
                id="password"
                class="form-control"
                placeholder="Password"
                required
              />
              <button type="button" class="toggle-password" @click="togglePasswordVisibility">
                <i :class="passwordVisible ? 'icon-eye-off' : 'icon-eye'"></i>
              </button>
            </div>
          </div>
          <div class="text-center">
            <button type="submit" class="submit-btn">Proceed</button>
          </div>
        </form>
        <p class="text-center">
          Don’t have an account?
          <button @click="switchToSignup" class="link-button">Create Account</button>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'LogInComponent',
  data() {
    return {
      email: '',
      password: '',
      passwordVisible: false,
    };
  },
  methods: {
    ...mapActions('configurerAuth', { signIn: 'login' }),
    switchToSignup() {
      this.$emit('switch-view', 'signup'); // Notify parent to switch view
    },
    async login() {
      if (this.email && this.password) {
        try {
          await this.signIn({ email: this.email, password: this.password });

          this.$swal({
            icon: 'success',
            title: 'Login successful',
            text: 'Welcome back!',
            timer: 3000,
            showConfirmButton: false,
          });

          // Redirect to the "Customize" page
          this.$router.push('/configure/user/customize');
        } catch (error) {
          this.$swal({
            icon: 'error',
            title: 'Login Failed',
            text: error.message || 'Check your credentials and try again.',
          });
        }
      } else {
        // Show error if fields are empty
        this.$swal({
          icon: 'error',
          title: 'Please fill in all fields',
          text: 'Email and password are required.',
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
  },
};
</script>

<style scoped>
.login-section {
  font-family: "Work Sans", sans-serif;
  padding: 40px;
  /* Glassmorphism */
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);

  border-radius: 24px;
  max-width: 420px;
  margin: 20px auto;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.1);
}

.text-center {
  text-align: center;
  margin-bottom: 24px;
}

h3 {
  font-weight: 600;
  color: #2c3e50;
  font-size: 1.25rem;
  margin-bottom: 2rem;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #2c3e50;
  font-size: 0.9rem;
}

.form-control {
  width: 100%;
  height: 48px;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  transition: all 0.3s ease;
}

.form-control:focus {
  background: #ffffff;
  border-color: #007D53;
  box-shadow: 0 0 0 3px rgba(0, 125, 83, 0.1);
  outline: none;
}

.password-container {
  display: flex;
  align-items: center;
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  color: #6c757d;
}

.submit-btn {
  width: 100%;
  height: 48px;
  background: #007D53;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 125, 83, 0.2);
}

.submit-btn:hover {
  background: #006644;
  transform: translateY(-1px);
  box-shadow: 0 6px 12px rgba(0, 125, 83, 0.3);
}

.link-button {
  background: none;
  border: none;
  color: #007D53;
  cursor: pointer;
  font-weight: 600;
  text-decoration: none;
  font-size: 14px;
  margin-left: 5px;
}

.link-button:hover {
  text-decoration: underline;
}
</style>
